import { useAuth } from "@/contexts/AuthContext";
import { Link } from "react-router-dom";
import { AlertCircle, Mail, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NoWorkspacePage() {
  const { user, logout } = useAuth();

  return (
    <div className="flex items-center justify-center min-h-[60vh]" data-testid="no-workspace-page">
      <div className="max-w-md text-center space-y-6">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-amber-500/10 rounded-full mx-auto">
          <AlertCircle className="h-8 w-8 text-amber-400" />
        </div>
        <h1 className="text-2xl font-bold text-white">Aucun espace actif</h1>
        <p className="text-[#94A3B8] leading-relaxed">
          Votre compte <strong className="text-white">{user?.email}</strong> n'a pas encore d'espace de travail actif.
        </p>
        <div className="bg-[#151B2B] border border-[#2A3441] rounded-xl p-6 text-left space-y-3">
          <p className="text-sm text-[#94A3B8]">Cela peut signifier :</p>
          <ul className="text-sm text-[#94A3B8] space-y-2 list-disc list-inside">
            <li>Votre organisation est en cours de validation</li>
            <li>Votre abonnement n'est pas encore active</li>
            <li>Votre administrateur n'a pas encore configure votre acces</li>
          </ul>
        </div>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <a
            href="mailto:contact@glotechdigital.fr"
            className="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg bg-[#0099CC] text-white text-sm font-medium hover:bg-[#0088B5] transition-colors"
          >
            <Mail className="h-4 w-4" />
            Contacter le support
          </a>
          <Button
            variant="outline"
            onClick={logout}
            className="border-[#2A3441] text-[#94A3B8] hover:text-white hover:bg-[#151B2B]"
            data-testid="no-workspace-logout-btn"
          >
            Se deconnecter
          </Button>
        </div>
      </div>
    </div>
  );
}
